import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute,
} from "./SidebarElements";
import { useTranslation } from "react-i18next";

const Sidebar = ({ isOpen, toogle }) => {
  const { t } = useTranslation();

  return (
    <SidebarContainer isOpen={isOpen} onClick={toogle}>
      <Icon onClick={toogle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          {/* <SidebarLink
            to="/home"
            onClick={toogle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            {t("sidebar.home")}
          </SidebarLink> */}

          <SidebarLink
            to="/sobre-mi"
            onClick={toogle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            {t("sidebar.about")}
          </SidebarLink>

          <SidebarLink
            to="/proyectos"
            onClick={toogle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            {t("sidebar.projects")}
          </SidebarLink>


          <SidebarLink
            to="/tecnologias"
            onClick={toogle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            {t("sidebar.skills")}
          </SidebarLink>

          <SidebarLink
            to="/reparacion-de-PC"
            onClick={toogle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            Reparaciones de PC
          </SidebarLink>

        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute
            to="signin"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={toogle}
          >
            {t("sidebar.button")}
          </SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
